import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {maintenanceService} from "../../services/maintenanceService";

interface MaintenanceState {
    isInMaintenance: boolean;
    errors: string | null;
    isLoading: boolean;
}

const initialState: MaintenanceState = {
    isInMaintenance: false,
    errors: null,
    isLoading: false,
};

// Async thunk
export const fetchMaintenanceStatus = createAsyncThunk<boolean>(
    "maintenance/status",
    async () => {
        const response = await maintenanceService.status();
        return response?.active ?? false;
    }
);

const maintenanceSlice = createSlice({
    name: "maintenance",
    initialState,
    reducers: {
        setMaintenanceMode: (state, action) => {
            state.isInMaintenance = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMaintenanceStatus.pending, (state) => {
                state.isLoading = true;
                state.errors = null;
            })
            .addCase(fetchMaintenanceStatus.fulfilled, (state, action) => {
                state.isInMaintenance = action.payload;
                state.isLoading = false;
            })
            .addCase(fetchMaintenanceStatus.rejected, (state, action) => {
                state.errors = action.error.message || "Failed to fetch maintenance status";
                state.isLoading = false;
            });
    },
});

export const {setMaintenanceMode} = maintenanceSlice.actions;
export default maintenanceSlice.reducer;
